import { condenseColumnData, mapColumns } from '@nexio/emvio-util-ui';
import config from '../../config/config';

export const UPDATE_COLUMNS_LOAD = 'TABLE/UPDATE_COLUMNS_LOAD';
export const UPDATE_COLUMNS_SUCCESS = 'TABLE/UPDATE_COLUMNS_SUCCESS';
export const UPDATE_COLUMNS_FAILURE = 'TABLE/UPDATE_COLUMNS_FAILURE';
export const COLUMNS_FAILURE = 'TABLE/COLUMNS_FAILURE';
export const COLUMNS_LOAD = 'TABLE/COLUMNS_LOAD';
export const COLUMNS_SUCCESS = 'TABLE/COLUMNS_SUCCESS';
export const UPDATE_DATE_RANGE = 'TABLE/UPDATE_DATE_RANGE';
export const TABLE_UNMOUNT = 'TABLE/TABLE_UNMOUNT';

export function onUnmount() {
    return {
        type: TABLE_UNMOUNT
    };
}

export function goToUrl(history, url, newTab) {
    if (newTab) {
        window.open(url);
    } else {
        history.push(url);
    }
}

export function updateDateRange(dateRange) {
    return {
        dateRange,
        type: UPDATE_DATE_RANGE
    };
}

export function createUpdateColumnsSettingsFailureActionCreator(uniqueTableName) {
    return (error) => ({
        error,
        type: UPDATE_COLUMNS_FAILURE,
        uniqueTableName
    });
}

export function createUpdateColumnsSettingsLoadActionCreator(uniqueTableName, columns, sorts) {
    return () => {
        return {
            columns,
            sorts,
            type: UPDATE_COLUMNS_LOAD,
            uniqueTableName
        };
    };
}

export function updateColumnsSettings(uniqueTableName, columns, sorts) {
    const columnsToSend = condenseColumnData(columns);

    return {
        failureActionTypeOrCreator: createUpdateColumnsSettingsFailureActionCreator(uniqueTableName),
        fetchParams: {
            body: { [`${uniqueTableName}Table`]: { columns: columnsToSend, sorts } },
            method: 'POST',
            url: `${config.userSettingsApiUrl}`
        },
        loadActionTypeOrCreator: createUpdateColumnsSettingsLoadActionCreator(uniqueTableName, columns, sorts),
        successActionTypeOrCreator: UPDATE_COLUMNS_SUCCESS
    };
}

export function createGetColumnsSettingsSuccessActionCreator(uniqueTableName, defaultColumnsAndProps) {
    return (transactionsTableSettings = {}) => {
        const columns = mapColumns(transactionsTableSettings.columns, defaultColumnsAndProps);

        return {
            columns,
            sorts: transactionsTableSettings.sorts,
            type: COLUMNS_SUCCESS,
            uniqueTableName
        };
    };
}

export function createGetColumnsSettingsFailureActionCreator(uniqueTableName, defaultColumnsAndProps) {
    return (error) => ({
        columns: mapColumns(null, defaultColumnsAndProps),
        error,
        type: COLUMNS_FAILURE,
        uniqueTableName
    });

}

export function createGetColumnsSettingsLoadActionCreator(uniqueTableName) {
    return () => ({
        type: COLUMNS_LOAD,
        uniqueTableName
    });
}

export function getColumnsSettings(uniqueTableName, defaultColumnsAndProps) {
    return {
        failureActionTypeOrCreator: createGetColumnsSettingsFailureActionCreator(uniqueTableName, defaultColumnsAndProps),
        fetchParams: {
            url: `${config.userSettingsApiUrl}/${uniqueTableName}Table`
        },
        loadActionTypeOrCreator: createGetColumnsSettingsLoadActionCreator(uniqueTableName),
        successActionTypeOrCreator: createGetColumnsSettingsSuccessActionCreator(uniqueTableName, defaultColumnsAndProps)
    };
}
